import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import React, { useEffect, useRef } from "react";

gsap.registerPlugin(ScrollTrigger);

function Progress({ title, percentage }) {
  const barRef = useRef(null);

  useEffect(() => {
    const bar = barRef.current;
    const st = ScrollTrigger.create({
      trigger: bar,
      start: "top 90%",
      once: true,
      onEnter: () =>
        gsap.fromTo(bar, { width: 0 }, {
          width: `${percentage}%`,
          duration: 1.2,
          ease: "power2.out",
        }),
    });
    return () => st.kill();
  }, [percentage]);

  return (
    <div className="mi-progress">
      <h6 className="mi-progress-title">{title}</h6>
      <div className="mi-progress-inner">
        <div className="mi-progress-percentage">{`${percentage}%`}</div>
        <div className="mi-progress-container">
          <span ref={barRef} className="mi-progress-active"></span>
        </div>
      </div>
    </div>
  );
}

export default Progress;
